<template>
  <div>
    <h4 class="mb-2 mt-2">1. DEFINITIONS</h4>
    <p>
      <b>1.1 Acceptable Use Policy:</b> The policy governing the use of the
      Products and Services by a Customer whether required by Lyca Mobile or the
      telecommunications operator of any Network that facilitates access to the
      Services. The Acceptable Use Policy is described in Section 5 below.
    </p>

    <p>
      <b>1.2 Account:</b> The mobile telephone account registered or activated
      by a Customer that Lyca Mobile uses to provide the Products and Services
      and which logs a Customer’s use of the Products and Services.
    </p>
    <p><b>1.3 Agreement:</b></p>
    <ul>
      <li>
        In addition to these general terms and conditions, there are several
        parts of the Agreement, which may include but is not limited to i) the
        User Guide accompanying the SIM Card or available at
        <a href="https://www.lycamobile.us/en/" target="_blank">
          www.lycamobile.us</a
        >
        ; ii)the Charges for Services published by Lyca Mobile from time to
        time, including any special offers; iii) the transaction materials that
        you sign or accept (via electronic acceptance online or through a Lyca
        Mobile retail location or that of an authorized retailer) during the
        sales transaction (if your service plan is not specifically
        <a href="https://www.lycamobile.us/en/" target="_blank">
          www.lycamobile.us</a
        >
        set forth in any printed materials, the requirements and terms set forth
        in the current written services and transaction materials apply,
        excluding the plan charges and number of minutes included in your
        service plan); and (iv) any confirmation materials that we may provide
        to you. It is important that you carefully read all of the terms of the
        Agreement.
        <b>
          AGREEMENT CONTAINS A MANDATORY ARBITRATION PROVISION THAT DISALLOWS
          CLASS ACTIONS, A CLASS ACTION WAIVER PROVISION, AND A JURY WAIVER
          PROVISION.</b
        >
      </li>
      <li>
        The Agreement starts when a Customer purchases a SIM Card or Top-Up
        Voucher, registers or activates an Account, uses our Top-Up Services or
        other Services, whichever occurs first.
      </li>
      <li>
        You represent that you are at least 18 years old and you are legally
        authorized to enter into this Agreement. You accept your Agreement by
        doing any of the following: <br />
        (a) giving us a written or electronic signature, or telling us orally
        that you accept;<br />
        (b) activating Service<br />
        (c) using your Service; <br />(d) paying for the Service or a SIM
        (purchased from Lyca Mobile, a Lyca Mobile dealer or other Lyca Mobile
        authorized retailer).
      </li>
    </ul>

    <p>
      <b>1.4 Charges:</b> The advertised Plan, Pay-As-You-Go rates, Data-Add-Ons
      and auto-renewal charges will be subject to a five percent (5%) regulatory
      recovery fee (“Charges”). Note also that there may be sales and other
      required taxes charged by the retailer where you purchase your Lyca Mobile
      products.
    </p>
    <p>
      <b>1.5 Customer:</b> Any individual, company or other entity that
      purchases a SIM Card, Top-Up Voucher, registers or activates an Account
      with Lyca Mobile or uses the Services. In these general terms and
      conditions, the Customer is sometimes referred to as “you” or “your”.
    </p>
    <p>
      <b>1.6 Customer Services Department:</b> The department of Lyca Mobile
      that you may contact for any enquiries about the Products or Services. You
      may contact the Customer Services Department in several ways:
    </p>
    <ul>
      <li>
        Dial 612 from a mobile phone with a Lyca Mobile Account (at no cost),
      </li>
      <li>
        Dial 845-301-1612 FREE from any other telephone (local call charges may
        apply),
      </li>
      <li>
        Dial +1-845-301-1612 from any other telephone while abroad
        (international roaming charges apply),
      </li>
      <li>Dial 1-866-277-3221 from any phone (at no cost),</li>
      <li>
        Visit the Lyca Mobile website at
        <a href="https://www.lycamobile.us/en/" target="_blank">
          www.lycamobile.us</a
        >
        (and click on the “Contact” link at the bottom of the page or on the
        “Contact Us” subsection of the “Help” tab at the top of the page),
      </li>
      <li>E-mail the Customer Services Department at cs@lycamobile.us, or</li>
      <li>
        Write to Customer Services Department at the address listed in Section
        1.8 below.
      </li>
    </ul>
    <p>
      <b>1.7 Device:</b> A GSM mobile telephone, handset, or other device used
      to access the Services.
    </p>
    <p>
      <b>1.8 Lyca Mobile:</b> Lyca Mobile USA, Inc. or our subsidiaries,
      affiliates, parent companies, vendors, suppliers, or licensors. In these
      general terms and conditions, Lyca Mobile is sometimes referred to as
      “we”, “us” or “our”. Lyca Mobile USA, Inc. contact mailing address: 24
      Commerce Street, Suite 100, Newark, New Jersey, 07102.
    </p>
    <p>
      <b>1.9 Network:</b> The telecommunications networks used by Lyca Mobile to
      provide the Services to you.
    </p>
    <p>
      <b>1.10 Personal Data:</b> The personal information that you provide to
      Lyca Mobile or that Lyca Mobile generates, collects, uses, processes and
      stores about you while providing the Services, including but not limited
      to your name, address, date of birth, mobile telephone number, call data
      records including Traffic Data and Location Data, top-up records, credit
      card or debit card details, billing records, voice mail recordings, copies
      of e-mails including your e-mail address, and records of Customer Services
      Department enquiries made by you.
    </p>
    <p>
      <b>1.11 Privacy Policy:</b> The policy that describes how Lyca Mobile
      generates, collects, uses, processes and stores your Personal Data.
    </p>
    <p>
      <b>1.12 Products:</b> The Lyca Mobile or GT Mobile SIM Card and Lyca
      Mobile or GT Mobile Top-Up Voucher, and any other branded products or
      services offered by Lyca Mobile, including promotional products and
      services.
    </p>
    <p>
      <b>1.13 Roaming Services:</b> The mobile telephone services that you use
      when travelling outside the United States or outside an area where Lyca
      Mobile service is provided.
    </p>
    <p>
      <b>1.14 Services:</b> The mobile telephone services that Lyca Mobile
      provides to you, including voice calling, messaging and data services,
      voicemail, calling line identification presentation (CLIP), calling line
      identification restriction (CLIR), Top-Up Services, Roaming Services and
      the services provided by the Customer Services Department.
    </p>
    <p>
      <b>1.15 SIM Card:</b> The prepaid, pre-activated card that allows you to
      access and use the Services by inserting it into a compatible Device.
    </p>
    <p>
      <b>1.16 Taxes, Fees, and Surcharges Taxes and Fees.</b> You agree to pay
      all taxes and fees imposed by governments or governmental entities. All
      advertised pricing for Lyca Mobile Services includes taxes and fees. We
      may not give advance notice of changes to the Charges, taxes or fees. All
      website purchases, including auto-recharges, will be assessed the Charge,
      which are currently set at a flat rate of five percent (5%). These Charges
      are not mandated by law, but are collected and retained by Lyca Mobile in
      whole or in part. The components and amounts of these Charges are subject
      to change without notice. The Charges include, but are not limited to
      charges, costs, fees and certain taxes Lyca Mobile incurs to provide
      Services (and are not government taxes or fees imposed directly on our
      customers that we must collect by law). Examples include general and
      administrative fees (such as certain costs we incur to provide Service) as
      well as governmental-related surcharges (such as Federal or State
      Universal Service fees, E-911 fees, regulatory fees, and gross receipts
      taxes). The Charges will apply whether or not you benefit from the
      Service. If the advertised rates do not include certain taxes, fees and
      Charges, you will receive notice of their amounts and applicability prior
      to purchase.<br />
      <b>Surcharges.</b> You agree to pay all Surcharges. Surcharges are not
      mandated by law, they are Lyca Mobile Charges that are collected and
      retained by Lyca Mobile in whole or in part. The components and amounts of
      these Charges are subject to change without notice. Surcharges include,
      but are not limited to charges, costs, fees and certain taxes Lyca Mobile
      incurs to provide Services (and are not government taxes or fees imposed
      directly on our customers that we must collect by law). Examples include
      general and administrative fees (such as certain costs we incur to provide
      Service) as well as governmental-related Surcharges (such as Federal or
      State Universal Service fees, E-911 fees, regulatory fees, and gross
      receipts taxes). Surcharges will apply whether or not you benefit from the
      programs, activities or services included in the Surcharge. Depending on
      your Services, we may deduct from your Account balance all Taxes, Fees and
      Surcharges that we’re required by law to collect and remit to the
      government on the Services that we provide to you. If the advertised rates
      do not include certain Taxes, Fees and Surcharges, you will receive notice
      of their amounts and applicability prior to purchase.
    </p>
    <p>
      <b>1.17 Top-Up Services:</b> The services you may use to add credit to the
      balance of your Account, including the Top-Up Voucher, Online Top-Up and
      Auto Top-Up.
    </p>
    <p>
      <b>1.18 Top-Up Voucher:</b> A multifunction voucher (whether in physical
      or electronic form) containing a multi- digit code that allows you to
      access and use the Services by redeeming the face value of the voucher.
    </p>
    <p>
      <b>1.19 User Guide:</b> The guide or documentation supplied with your SIM
      Card or listed at
      <a href="https://www.lycamobile.us/en/" target="_blank">
        www.lycamobile.us</a
      >, which explains how you may access and use the Services.
    </p>
    <h4 class="mb-2 mt-2">2. PLANS</h4>
    <p>
      “Bundle is excluded from Morocco IAM and Wana destinations” $15 Plan:
      Limited time offer. Must purchase 12 plans at a time – individual 30-day
      plans not sold separately. Plan expires after 360 days. All website
      purchases, including auto-recharges, will be assessed a regulatory
      recovery fee of 5%. Plan only valid for calls, texts and data usage from
      the US. Each 30-day plan includes 250MB of up to 5G speed data only. No
      additional data is included after high speed data allotment is used. USA
      includes 50 states and Puerto Rico. Texts to 900 numbers are not included.
      Purchase of international or roaming credit required to enable additional
      features (like international talk to countries not listed). Offer of
      unlimited international calls to Lyca Mobile numbers only valid when both
      numbers are not roaming. No national roaming (voice, text and data not
      available in off-net areas – see coverage map for details). For
      non-commercial, personal use only. Service may be suspended/terminated if
      used in violation of Acceptable Use Policy. SIM and assigned number expire
      after 60 days of non-use. Offer terms at time of plan activation apply,
      regardless of purchase date. Plans, rates & services are subject to change
      without notice & are not available in all locations or for all phones.
    </p>
    <p>
      <b>$15 Unlimited Plan:</b> Below is the list of 75+ countries included
      with select plans :<br />
      Include Landline & Mobile Australia | Austria | Belgium | Bermuda|Brazil |
      Bulgaria | Canada | Chile | China | Colombia | Croatia | Czech Republic |
      Denmark | Finland | France | Germany | Greece | Guam | Hong Kong | Hungary
      | Iceland | India | Indonesia | Ireland | Israel | Italy | Kuwait | Macau
      | Malaysia | Malta | Martinique | Mexico | Mongolia | Netherlands | New
      Zealand | Norway | Paraguay | Peru | Poland | Portugal | Romania |
      Singapore | South Korea | Spain | Sweden | Thailand | United Kingdom |
      Ukraine Kyivstar | Philippines Smart <br />
      <b>Landline Only</b> <br />
      American Samoa | Andorra | Argentina | Brunei Darussalam | Costa Rica |
      Dominican Republic | Estonia | Gibraltar | Guadeloupe | Japan | Kazakhstan
      | Latvia | Lithuania | Luxembourg | Morocco | Namibia | Panama | Russia |
      San Marino | Slovakia | Slovenia | South Africa | Swaziland | Switzerland
      | Taiwan | Turkey | Uruguay | Venezuela<br />
      <b>$19 Unlimited National Plan:</b>
      Limited time offer. Plan expires after 30 days. All website purchases,
      including auto-recharges, will be assessed a regulatory recovery fee of
      5%. Plan only valid for calls, texts and data usage from the US. Lines
      activated prior to April 5, 2022 receive 2GB of high speed data per plan
      period. Speeds slowed to 2G after high speed data allotment is used.
      During periods of congestion, customers may experience reduced data speeds
      as compared to MNO postpaid customers. USA includes 50 states and Puerto
      Rico. Texts to 900 numbers are not included. Purchase of international or
      roaming credit required to enable additional features (like international
      talk to countries not listed). Offer of unlimited international calls to
      Lyca Mobile numbers only valid when both numbers are not roaming. No
      national roaming (voice, text and data not available in off-net areas –
      see coverage map for details). For non-commercial, personal use only.
      Service may be suspended/terminated if used in violation of Acceptable Use
      Policy. SIM and assigned number expire after 60 days of non-use. Offer
      terms at time of plan activation apply, regardless of purchase date.
      Plans, rates & services are subject to change without notice & are not
      available in all locations or for all phones. <br />
      Price breakdown: Data= $7.62; Talk/Text= $11.38<br />
      <b>$23 Unlimited National Plan:</b> Limited time offer. Plan expires after
      30 days. All website purchases, including auto-recharges, will be assessed
      a regulatory recovery fee of 5%. Plan only valid for calls, texts and data
      usage from the US. Lines activated prior to April 5, 2022 receive 3GB of
      high speed data per plan period. Speeds slowed to 2G after high speed data
      allotment is used. During periods of congestion, customers may experience
      reduced data speeds as compared to MNO postpaid customers. USA includes 50
      states and Puerto Rico. Texts to 900 numbers are not included. Purchase of
      international or roaming credit required to enable additional features
      (like international talk to countries not listed). Offer of unlimited
      international calls to Lyca Mobile numbers only valid when both numbers
      are not roaming. No national roaming (voice, text and data not available
      in off-net areas – see coverage map for details). For non-commercial,
      personal use only. Service may be suspended/terminated if used in
      violation of Acceptable Use Policy. SIM and assigned number expire after
      60 days of non-use. Offer terms at time of plan activation apply,
      regardless of purchase date. Plans, rates & services are subject to change
      without notice & are not available in all locations or for all phones.<br />
      Price breakdown: Data= $15.07; Talk/Text= $7.93 <br />
      <b>$29 Unlimited International Plan:</b> <br />
      Limited time offer. Plan expires after 30 days. All website purchases,
      including auto-recharges, will be assessed a regulatory recovery fee of
      5%. Plan only valid for calls, texts and data usage from the US. Lines
      activated prior to April 5, 2022 receive 6GB of high speed data per plan
      period. Speeds slowed to 2G after high speed data allotment is used.
      During periods of congestion, customers may experience reduced data speeds
      as compared to MNO postpaid customers. USA includes 50 states and Puerto
      Rico. Texts to 900 numbers are not included. Purchase of international or
      roaming credit required to enable additional features (like international
      talk to countries not listed). Offer of unlimited international calls to
      Lyca Mobile numbers only valid when both numbers are not roaming. No
      national roaming (voice, text and data not available in off-net areas –
      see coverage map for details). For non-commercial, personal use only.
      Service may be suspended/terminated if used in violation of Acceptable Use
      Policy. SIM and assigned number expire after 60 days of non-use. Offer
      terms at time of plan activation apply, regardless of purchase date.
      Plans, rates & services are subject to change without notice & are not
      available in all locations or for all phones. <br />
      Price breakdown: Data= $21.31; Talk/Text= $7.69 <br />
      <b>$33 Unlimited National Plan:</b> <br />
      Limited time offer. Plan expires after 30 days. All website purchases,
      including auto-recharges, will be assessed a regulatory recovery fee of
      5%. Plan only valid for calls, texts and data usage from the US. Lines
      activated prior to April 5, 2022 receive 9GB of high speed data per plan
      period. Speeds slowed to 2G after high speed data allotment is used.
      During periods of congestion, customers may experience reduced data speeds
      as compared to MNO postpaid customers. USA includes 50 states and Puerto
      Rico. Texts to 900 numbers are not included. Purchase of international or
      roaming credit required to enable additional features (like international
      talk to countries not listed). Offer of unlimited international calls to
      Lyca Mobile numbers only valid when both numbers are not roaming. No
      national roaming (voice, text and data not available in off-net areas –
      see coverage map for details). For non-commercial, personal use only.
      Service may be suspended/terminated if used in violation of Acceptable Use
      Policy. SIM and assigned number expire after 60 days of non-use. Offer
      terms at time of plan activation apply, regardless of purchase date.
      Plans, rates & services are subject to change without notice & are not
      available in all locations or for all phones.
      <br />Price breakdown: Data= $28.86; Talk/Text= $6.14 <br />
      <b>$40 Unlimited National Plan:</b> <br />Limited time offer. Plan expires
      after 30 days. All website purchases, including auto-recharges, will be
      assessed a regulatory recovery fee of 5%. Plan only valid for calls, texts
      and data usage from the US. First 15GB of data at up to 5G speed and
      remainder at reduced speeds. USA includes 50 states and Puerto Rico. Texts
      to 900 numbers are not included. Purchase of international or roaming
      credit required to enable additional features (like international talk to
      countries not listed). Offer of unlimited international calls to Lyca
      Mobile numbers only valid when both numbers are not roaming. No national
      roaming (voice, text and data not available in off-net areas – see
      coverage map for details). For non-commercial, personal use only. Service
      may be suspended/terminated if used in violation of Acceptable Use Policy.
      SIM and assigned number expire after 60 days of non-use. Offer terms at
      time of plan activation apply, regardless of purchase date. Plans, rates &
      services are subject to change without notice & are not available in all
      locations or for all phones.<br />
      Price breakdown: Data= $31.05; Talk/Text= $7.95 <br />
      <b>$49 Unlimited National Plan:</b><br />
      Limited time offer. Plan expires after 30 days. After 40GB 4G/5G allotment
      is used, speeds will be reduced for the remainder of the plan. During
      periods of congestion, customers may experience reduced data speeds as
      compared to Carrier postpaid customers. Tethering (hotspot) not permitted.
      All website purchases, including auto-recharges, will be assessed a
      regulatory recovery fee of 5%. Plan only valid for calls, texts and data
      usage from the US. USA includes 50 states and Puerto Rico. Texts to 900
      numbers are not included. Purchase of international or roaming credit
      required to enable additional features (like international talk to
      countries not listed). Offer of unlimited international calls to Lyca
      Mobile numbers only valid when both numbers are not roaming. US roaming
      allotment: 200 minutes; 200 texts; 0 data (see coverage map for details).
      For non-commercial, personal use only. Service may be suspended/terminated
      if used in violation of Acceptable Use Policy. SIM and assigned number
      expire after 60 days of non-use. Offer terms at time of plan activation
      apply, regardless of purchase date. Plans, rates & services are subject to
      change without notice & are not available in all locations or for all
      phones.<br />
      Price breakdown: Data= $41.34; Talk/Text= $8.66 <br />
      <b>$59 Unlimited National Plan:</b> <br />
      Limited time offer. Plan expires after 30 days. After 60GB 4G/5G allotment
      is used, speeds will be reduced for the remainder of the plan. During
      periods of congestion, customers may experience reduced data speeds as
      compared to Carrier postpaid customers. Tethering (hotspot) not permitted.
      All website purchases, including auto-recharges, will be assessed a
      regulatory recovery fee of 5%. Plan only valid for calls, texts and data
      usage from the US. USA includes 50 states and Puerto Rico. Texts to 900
      numbers are not included. Purchase of international or roaming credit
      required to enable additional features (like international talk to
      countries not listed). Offer of unlimited international calls to Lyca
      Mobile numbers only valid when both numbers are not roaming. No national
      roaming (voice, text and data not available in off-net areas – see
      coverage map for details). For non-commercial, personal use only. Service
      may be suspended/terminated if used in violation of Acceptable Use Policy.
      SIM and assigned number expire after 60 days of non-use. Offer terms at
      time of plan activation apply, regardless of purchase date. Plans, rates &
      services are subject to change without notice & are not available in all
      locations or for all phones. *Please note unlimited calls to Pakistan and
      Senegal orange is subject to work only 10 dialed numbers.
    </p>
    <h4 class="mb-2 mt-2">3. THE SERVICES</h4>
    <p>
      <b>3.1</b> Lyca Mobile will immediately connect you to the Services as
      soon as you register or activate your Account. As long as you have
      sufficient credit in your Account, you will be able to continue using the
      Services until either Lyca Mobile or you decide to end the Agreement in
      the ways allowed in this Agreement.
    </p>
    <p>
      <b>3.2</b> Lyca Mobile will provide the Services to you using its own
      Network and the Networks of one or more telecommunications operators.
      Occasionally any of these Networks may be unavailable for maintenance,
      modifications, upgrades, emergencies or to protect the security of the
      Network. At these times the Services may be temporarily unavailable. When
      possible, Lyca Mobile will provide you with advance notice of scheduled
      outages.
    </p>
    <p>
      <b>3.3</b> Mobile telephony is a form of wireless communication and
      operates on the basis of the transmission of radio and signal frequencies.
      The transmission of these radio and signal frequencies may be affected by
      congestion on the Network due to the number of calls or messages or the
      amount of data being sent and received. Coverage maps only approximate our
      anticipated wireless coverage area outdoors.
    </p>
    <p>
      <b>3.4</b> The transmission of the radio and signal frequencies may also
      be affected by the location of the base stations, obstacles such as
      buildings or underpasses, and by external factors such as geographic or
      atmospheric conditions. The Services may also be affected by the quality
      of the Device chosen and used by you.
    </p>
    <p>
      <b>3.5</b> The Roaming Services are subject to the roaming contracts and
      service quality levels that have been agreed between other national and
      international telecommunications operators. Lyca Mobile does not have any
      control over the contracts or service quality levels agreed between these
      telecommunications operators. Your Device may connect to another
      provider’s network even when you are within the Lyca Mobile coverage area,
      referred to as being “Off-Net”. Customer’s should check the Device to
      determine if you are Off-Net. There may be extra Charges (including long
      distance, tolls, data usage) and higher rates for Off-Net usage, depending
      on your purchased Services. You must use your Device predominantly within
      the Lyca Mobile supplied network coverage area. If your Off-Net voice
      usage, data usage or messaging usage exceeds your purchased Services
      allotment, your access to Off-Net coverage may be suspended or denied. We
      may also limit or terminate your Service in our discretion and without
      prior notice if you no longer reside in a Lyca Mobile network coverage
      area, or if your Off-Net usage makes it uneconomical for Lyca Mobile to
      provide Service to you, or if related to Lyca Mobile’s or its network
      supplier’s arrangements with an Off-Net provider.
    </p>
    <p>
      <b>3.6</b> For the reasons described above, Lyca Mobile does not warrant
      or guarantee that the Services will be uninterrupted or error free (in
      terms of Network availability, quality or coverage) in all locations at
      all times, or that the Services will be suitable for your specific
      requirements, or that the Services will be completely secure against
      unauthorized interception.
    </p>
    <p>
      <b>3.7</b> Lyca Mobile will endeavor to keep any disruption to the
      Services to a minimum; however Lyca Mobile will not be liable to you for
      any loss, damage or inconvenience incurred by you as a result of any
      disruption to the Services for the reasons described above.
    </p>
    <p>
      <b>3.8</b> Certain types of calls or messages may be excluded from the
      Services, such as certain premium rate services (such as 900 numbers). We
      reserve the right to restrict access to these telephone numbers and
      services.
    </p>
    <p>
      <b>3.9</b> We do not guarantee or endorse any third party content that you
      may access or use. Your use of any third party content is entirely at your
      own risk. We do not guarantee access to third party content where you
      access or download the content from the internet or upload or transmit
      content using the Services.
    </p>
    <p>
      <b>3.10</b> Itemized statements or your Account and the record of your use
      of the Services, including calls and messages made and received and top-up
      information, are excluded from the Services. You may access this
      information by logging into your Account.
    </p>
    <p>
      <b>3.11</b> Our Customer Services Department can supply details of the
      other mobile operators we have porting arrangements with and how you may
      port your number. We don’t guarantee that number transfers to or from us
      will be successful. If you authorize another carrier to transfer a number
      away from us, then that is considered a request by you to us to terminate
      all of the Services associated with that number.<b>
        NOTE: If you wish to port out your number from Lyca Mobile to a new
        carrier, you must have an active Lyca Mobile account. If your account is
        inactive (i.e., it has no active plan or funds balance), your number
        will be ineligible for port-out.</b
      >
    </p>
    <p>
      <b>3.12</b> We can, without notice, suspend or terminate any Service at
      any time for any reason. For example, we can suspend or terminate any
      Service for the following:<br />
      (a) failure to have or maintain an appropriate account balance for
      applicable charges;<br />
      (b) harassing/threatening/abusing/offending our employees or agents;<br />
      (c) providing false or inaccurate information; <br />
      (d) interfering with our operations; <br />
      (e) using/suspicion of using Services in any manner restricted by or
      inconsistent with the Agreement;<br />
      (f) breaching, failing to follow, or abusing the Agreement; <br />(g)
      modifying a SIM from its manufacturer specifications; or <br />(h) if we
      believe the action protects our interests, any customer’s interests, or
      our networks.
    </p>
    <p>
      <b>3.13</b> If Lyca Mobile provides you software as part of the Service or
      Device and there are not software license terms provided with the software
      (by Lyca Mobile or by a third party), then Lyca Mobile grants you a
      limited, revocable, non-exclusive, non-transferable license to use the
      software to access the Services for your own individual use. You will not
      sell, resell, transfer, copy, translate, publish, create derivative works
      of, make any commercial use of, modify, reverse engineer, decompile, or
      disassemble the software. Lyca Mobile may revoke this license at any time.
    </p>
    <p>
      <b>3.14</b> Lyca Mobile may charge activation, prepayment, reactivation,
      program, or other fees to establish or maintain Services. Certain
      transactions may also be subject to a charge (for example, convenience
      payment, changing phone numbers, handset upgrades, etc.). You will be
      provided notice of these types of fees before we complete the requested
      transaction.
    </p>
    <p>
      <b>3.15</b> We round up partial minutes of use to the next full minute.
      Time starts when you press “Call” (or the Device equivalent) or when your
      Device connects to the network and stops when you press “End” (or the
      Device equivalent) or the network connection otherwise breaks. You’re
      charged for all calls that connect, even to answering machines, voicemail,
      or voice transcription services. For incoming calls answered, you’re
      charged from the time shortly before the Device starts ringing until you
      press “End” or the network connection otherwise breaks. You’re charged for
      the entire call based on the rate that applies to the time period in which
      the call starts. However, the types of charges actually deducted from your
      account balance will vary depending on your Service. Data usage is rounded
      up to the next full-kilobyte increment at the end of each data session.
      There are 1,024 kilobytes in one megabyte.
    </p>
    <p>
      <b>3.16</b> Our Network will allow the display of your Device telephone
      number on receiving handsets unless you disable this feature on your
      Device.
    </p>
    <p>
      <b>3.17</b> International roaming and dialing are available with some
      service plans and on some Devices and may require the purchase of an
      additional feature on your account. Whether roaming internationally or
      making and sending international calls and messages while in the U.S. (or
      Puerto Rico), you will be charged international rates (including for
      voicemails left for you and for data usage). This includes per minute
      rates for calls and, while roaming internationally, per minute rates for
      calls transferred to your voicemail and the relevant data rates for data
      usage. You may be charged for more than one call for unanswered calls that
      are forwarded to voicemail regardless of whether the calls result in an
      actual voicemail message being left for you and regardless of whether your
      phone is on or off. Some Devices and applications may incur usage and
      Charges while roaming. You may be able to disable these applications and
      features through your Device settings. Different rates and rounding
      increments apply in different countries. While roaming internationally,
      your data throughput may be reduced and your Service may be otherwise
      limited or terminated at any time without notice.
    </p>
    <p>
      <b>3.18</b> Data Plans: You will be charged for data usage on a pay per
      use basis unless you maintain a plan that includes a set allotment of data
      (“Data Plan”) as part of your Service. Rates and charges may be found at
      <a href="https://www.lycamobile.us/en/" target="_blank">
        www.lycamobile.us</a
      >
      and are subject to change.
    </p>
    <ul>
      <li>
        Permissible and Prohibited Uses: Your Data Plan is intended for Web
        browsing, messaging, and similar activities on your Device and not on
        any other equipment. Unless explicitly permitted by your Data Plan,
        other uses, including for example, using your Device as a modem or
        tethering your Device to a personal computer or other hardware, are not
        permitted. Other examples of prohibited uses can be found in Section 5.
      </li>
      <li>
        Protective Measures: To provide a good experience for the majority of
        our customers and minimize capacity issues and degradation in network
        performance, we may take measures including temporarily reducing data
        throughput for a subset of customers who use a disproportionate amount
        of bandwidth. Additionally, in the event that a customer is in violation
        of the Permissible and Prohibited Data Uses listed above, we may reduce
        your data speed for the remainder of that billing cycle or terminate
        data service without prior notice or refund. We may also suspend,
        terminate, or restrict your data session or service if you use your Data
        Plan in a manner that interferes with other customers’ service, our
        ability to allocate network capacity among customers, or that otherwise
        may degrade service quality for other customers.
      </li>
      <li>
        Downloadable Content and Applications: You can purchase Content and
        Applications (e.g., downloadable or networked applications, wallpapers,
        ringtones, games, and productivity tools) (“Content & Apps”) for and
        with your compatible Device. Some Apps that you can purchase with your
        Device are not sold by Lyca Mobile; for these Apps, you can identify the
        third party seller at the point of purchase. For these third party
        purchases, Lyca Mobile is not responsible for the App, including
        download, installation, use, transmission failure, interruption, or
        delay, or any content or website you may be able to access through the
        App. Any support questions for these Apps should be directed to the
        third party seller identified at the point of purchase. When you use,
        download or install an App sold by a third party seller, you may be
        subject to license terms between you and the third party seller and App
        developer. When you use, download, or install Content or Apps that you
        purchase from Lyca Mobile, the Content or App is licensed to you by Lyca
        Mobile and may be subject to additional license terms between you and
        the creator/owner of the Content or App. Whether purchased from Lyca
        Mobile or a third party seller, any Content or App you purchase is
        licensed for personal, lawful, non-commercial use on your Device only.
        You may not transfer, copy, or reverse engineer any Content or App, or
        alter, disable or circumvent any digital rights management security
        features embedded in the Content or App. Some Devices or Content & Apps
        may continue to have contact with our network without your knowledge,
        which may result in additional Charges, for example, while roaming
        internationally. Software on your Device may automatically shut down or
        limit the use of Content & Apps or other features or Services without
        warning. Lyca Mobile is not responsible for any third party content,
        advertisements, or websites you may be able to access using your Device.
      </li>
      <li>
        Use of Information: Lyca Mobile may retain, use, and share information
        collected when you download, use, or install some Content or Apps, may
        update your Content or App remotely, or may disable or remove any
        Content or App at any time. Refer to Lyca Mobile’s Privacy Policy as
        well as the Content or App creator/owner’s privacy policy for
        information regarding the use of information collected when you
        download, install, or use any Content or App. We are not responsible for
        any transmission failure, interruption, or delay related to Content &
        Apps, or any content or website you may be able to access through the
        Content or App.
      </li>
    </ul>
    <h4 class="mb-2 mt-2">4. SIM CARD DEACTIVATION</h4>
    <p>
      <b>4.1</b> The SIM Card is used by inserting it into a compatible GSM
      Device. When the SIM Card has been inserted and you have registered or
      activated your Account, you will have access to, and be able to use, the
      Services.
    </p>
    <p>
      <b>4.2</b> Associated with your SIM Card is the PIN code (personal
      identification number) and the PUK code (personal unlocking key). The PIN
      and PUK codes must never be kept together. You will take every necessary
      precaution to preserve the secrecy of your PIN and PUK codes. You will be
      liable for any fraudulent or improper use of your SIM Card or Account that
      results from the intentional or accidental disclosure of your PIN or PUK
      code or the transfer of your SIM Card to another person.
    </p>
    <p>
      <b>4.3</b> Lyca Mobile will only replace a SIM Card when it is found to be
      defective by reason of faulty workmanship or design. Lyca Mobile may
      charge you for a replacement SIM Card if Lyca Mobile reasonably believes
      that you are responsible for the loss or damage of your original SIM Card
      or if someone has stolen your original SIM Card. It is your responsibility
      to promptly inform Lyca Mobile of any loss, damage or theft to your SIM
      Card, or any fraudulent or improper use of your SIM Card.
    </p>
    <p>
      <b>4.4</b> If you do not use your SIM Card to make a voice call, send a
      message, send/receive data, or purchase a top-up using the Top-Up Services
      for a period of sixty (60) days from the date you registered or activated
      your Account or your last use of the Services (whichever is later), your
      SIM Card will be deactivated. Lyca Mobile will contact you by SMS or
      e-mail advising you of the pending deactivation prior to expiration of the
      sixty (60) days period of non-use.
    </p>
    <p>
      <b>4.5</b> If you make a voice call, send a message or data, or purchase a
      top-up using the Top-Up Services after receipt of the non-use notice
      stated above but before sixty (60) days from the date you registered or
      activated your Account or your last use of the Services (whichever is
      later), your SIM Card will remain active. Any previous credit balance in
      your Account will remain available for you to use, and you will be able to
      access and use the Services.
    </p>
    <p>
      <b>4.6</b> If the SIM Card is deactivated, your specific telephone number
      will be reallocated to another Customer, you will not be able to access or
      use the Services, and you will not be entitled to a refund of any credit
      balance in your Account.
    </p>
    <h4 class="mb-2 mt-2">5. THE SERVICES CHARGES (Types of Charges)</h4>
    <p>
      Lyca Mobile typically assesses the following types of Charges:<br />
      (1) “pay-per-use charges,” which are charges assessed each time a Service
      is used; and/or <br />(2) “subscription charges,” which are Charges that
      allow you access to a Service or provide you a certain amount of use of a
      Service for a defined period of time. Subscription charges for Services
      end on the last day of your subscription period, EST. Also, depending on
      your Service purchased and settings made by you in your account, certain
      types of subscription charges may be assessed automatically upon
      activation and automatically assessed for subsequent subscription periods.
    </p>
    <p>
      <b>5.1</b> The Services are prepaid services. You are required to Top Up
      in advance so your Account is in credit. As Charges for certain Services
      are incurred they will be deducted from the amount credited to your
      Account. No bill or invoice or statement will be issued to you. You may
      check your credit balance from time-to-time by calling 611 or dialing
      *611# from your Lyca Mobile.
    </p>
    <p>
      <b>5.2</b> You pay for the Services by topping-up your Account using any
      one of the Top-Up Services available from Lyca Mobile. You may use the
      Top-Up Services at any time after registration or activation of your
      Account. There are several ways that you may top-up your Account:
    </p>
    <ol type="a">
      <li>
        You may purchase a Top-Up Voucher at any participating retail outlet and
        activate the PIN code by following the dialing instructions on the
        Top-Up Voucher. You may also activate the PIN code for a Top-Up Voucher
        purchased at a participating retail outlet by using the Online Top-Up
        Service.
      </li>
      <li>
        You may register your details with Lyca Mobile, purchase a Top-Up
        Voucher online and activate the PIN Code by using the Online Top-Up
        service.
      </li>
      <li>
        You may register your details with Lyca Mobile and subscribe to “My Lyca
        Mobile” and the Auto Top-Up Facility.
      </li>
      <li>
        You may register your details with Lyca Mobile and then contact the
        Customer Services Department.
      </li>
    </ol>
    <p>
      <b>5.3</b> When you top-up your Account, the amount of the top-up credit
      you purchased will be added to the credit balance in your Account at the
      time of your top-up.
    </p>
    <p>
      <b>5.4</b> The credit balance in your Account may only be used for the
      Services. You are not entitled to receive any cash refund for any credit
      balance remaining in your Account at any time, including where you fail to
      use the Services and your SIM Card has been deactivated or where this
      Agreement has been terminated.
    </p>
    <p>
      <b>5.5</b> Interest is not payable on any credit balance in your Account.
      Each time you use the Services (or someone else uses your Device) the
      credit balance in your Account will be reduced for the voice call, message
      or data you are making or sending according to the destination and the
      current Charges.
    </p>
    <p>
      <b>5.6</b> Top Up Vouchers shall expire on the date stated on the Voucher
      (if any). Please check all products before purchase to ensure that any
      expiration dates listed are after the date you will activate the voucher.
    </p>
    <h4 class="mb-2 mt-2">6. ACCEPTABLE USE POLICY</h4>
    <p>
      <b>6.1</b> You agree to use the SIM Card in a compatible GSM Device for
      the purpose of using the Services. Lyca Mobile does not support all GSM
      Devices (like those that are locked by a provider other than T-Mobile or
      those that are not approved for US use by T-Mobile). You are solely
      responsible for any fault with the GSM Device you provide which may cause
      interference or problems with your use of the Services. Any Device you
      purchase from Lyca Mobile or an authorized dealer is subject to section 11
      of these terms and conditions.
    </p>
    <p>
      <b>6.2</b> You agree not to use the SIM Card or the Services and not to
      permit another person to use your SIM Card or the Services:
    </p>
    <ul>
      <li>Fraudulently or in connection with a criminal offense;</li>
      <li>
        For the purpose of making an unsolicited communication or storing and/
        or communicating any material which is offensive, abusive, indecent,
        defamatory, obscene or menacing, a nuisance or a hoax, or which is a
        breach of privacy, an infringement of copyright, or is otherwise
        unlawful; • To knowingly and deliberately cause annoyance, inconvenience
        or needless anxiety to another person;
      </li>
      <li>
        To make any offensive, abusive, indecent, defamatory, obscene or
        menacing call to any Customer Services Department representative;
      </li>
      <li>
        To transmit a virus or other malicious software, use the Services in a
        manner that impairs the operation or security of the Network or may
        cause death, personal injury or damage to property;
      </li>
      <li>
        With equipment that is not approved for use with the Network, including,
        but not limited to, SIM-boxes and SIM-gateways;
      </li>
      <li>
        Accessing, or attempting to access without authority, the information,
        accounts or devices of others, or to penetrate, or attempt to penetrate,
        Lyca Mobile’s or another entity’s network or systems;
      </li>
      <li>
        Running software or other devices that maintain continuously active
        Internet connections when a computer’s connection would otherwise be
        idle, or “keep alive” functions (e.g. using a Data Plan for web
        broadcasting, operating servers, telemetry devices and/or supervisory
        control and data acquisition devices);
      </li>
      <li>
        To support calls to call forwarding services, onward calling services or
        calls to telephone numbers which pay a revenue share or resell to others
        or commercially exploit our Services;
      </li>
      <li>
        Assisting or facilitating anyone else in any of the above activities,
        and
      </li>
      <li>
        Otherwise than in compliance with the conditions of this Agreement.
      </li>
    </ul>
    <p>
      <b>6.3</b> If Lyca Mobile reasonably suspects that you have failed to
      comply with any of the provisions of Section 5.2, Lyca Mobile shall have
      the right to suspend, partially or fully, your access to the Services and/
      or terminate this Agreement without prior notice and with immediate
      effect. If Lyca Mobile terminates this Agreement for this reason, your SIM
      Card will be deactivated. If the SIM Card is deactivated, your specific
      telephone number will be reallocated to another Customer, you will not be
      able to access or use the Services, and you will not be entitled to a
      refund of any credit balance in your Account.
    </p>
    <p>
      <b>6.4</b> Upon activation of a SIM Card, the purchase of a Top-Up Voucher
      or the use of the Top-Up Services, you may be required to register your
      Personal Data with Lyca Mobile, such as your name, address, date of birth,
      credit card or debit card details. If Lyca Mobile determines that the
      Personal Data that you provide is false, Lyca Mobile shall have the right
      to suspend, partially or fully, your access to the Services and/ or
      terminate this Agreement without prior notice and with immediate effect.
      If Lyca Mobile terminates this Agreement for this reason, your SIM Card
      will be deactivated. If the SIM Card is deactivated, your specific
      telephone number will be reallocated to another Customer, you will not be
      able to access or use the Services, and you will not be entitled to a
      refund of any credit balance in your Account.
    </p>
    <h4 class="mb-2 mt-2">7. PRIVACY POLICY & AUTHENTICATION</h4>
    <p>
      <b>7.1</b> Lyca Mobile will only generate, collect, use, process and store
      your Personal Data in accordance with all applicable laws and regulations,
      as amended from time to time. As we provide telecommunications Products
      and Services to you (the account holder), we develop information about the
      quantity, technical configuration, type, location, and destination of
      telecommunications products and Services you use, as well as some other
      information found on your bill (“CPNI”). Under federal law, you have the
      right, and we have a duty, to protect the confidentiality of your CPNI.
      For example, we implement safeguards that are designed to protect your
      CPNI, including authentication procedures when you contact us.,
    </p>
    <p>
      <b>7.2</b> You may password protect your account information by
      establishing a password. You may also set a backup security question and
      answer in the event you forget your password. You agree to protect your
      password, and other account access credentials like your backup security
      question from loss or disclosure. You further agree that Lyca Mobile may,
      in our sole discretion, treat any person who presents your credentials
      that we deem sufficient for account access as you or an authorized user on
      the account for disclosure of information or changes in Service. You agree
      that we may contact you for Service-related reasons through the contact
      information that you provide, through the Services to which you subscribe,
      or through other available means, including text message, email, fax,
      recorded message, mobile, residential or business phone, or mail.
    </p>
    <p>
      <b>7.3</b> Our Privacy Policy is available at privacy policy. This policy
      may change from time to time, so review it with regularity and care.
    </p>
    <h4 class="mb-2 mt-2">8. DISPUTE RESOLUTION</h4>
    <p>
      <b>8.1</b> The parties each agree to first contact each other with any
      Disputes (defined below) and provide a written description of the problem,
      relevant documents and supporting information, and the proposed
      resolution.
    </p>
    <p>
      <b>8.2</b> The parties each agree to arbitrate all Disputes between us, on
      an individual basis, not on a class-wide or consolidated basis. This
      agreement to arbitrate is intended to be broadly interpreted. In
      arbitration, there’s no judge or jury. However, just as a court would, the
      arbitrator must honor the terms and limitations in the Agreement and can
      award damages and relief, including any attorneys’ fees authorized by law.
      The arbitrator’s decision and award is final and binding, with some
      exceptions under the Federal Arbitration Act (“FAA”), and judgment on the
      award may be entered in any court with jurisdiction. The parties each also
      agree as follows:
    </p>
    <ul>
      <li>
        “Disputes” are any claims or controversies against each other related in
        any way to or arising out of in any way our Services or the Agreement,
        including, but not limited to, coverage, billing services and practices,
        policies, contract practices (including enforceability), service claims,
        privacy, or advertising, even if it arises after Services have
        terminated. Disputes include claims that you bring against our
        employees, agents, affiliates, or other representatives or that we bring
        against you. It also includes but is not limited to claims related in
        any way to or arising out of in any way any aspect of the relationship
        between us, whether based in contract, tort, statute, fraud,
        misrepresentation, or any other legal theory.
      </li>
      <li>
        If either party wants to initiate a claim to arbitrate a Dispute, each
        agrees to send written notice to the other providing a description of
        the dispute, a description of previous efforts to resolve the dispute,
        relevant documents and supporting information, and the proposed
        resolution. Notice to Customer will be sent to the mailing address of
        record in the Account, or if none, by text message or email, and notice
        to us will be sent to: Legal Department, 24 Commerce Street, Suite 100,
        Newark, New Jersey, 07102. We each agree to make attempts to resolve the
        dispute prior to filing a claim for arbitration. If we each cannot
        resolve the dispute within forty-five (45) days of receipt of the notice
        to arbitrate, then we each may submit the dispute to formal arbitration.
      </li>
      <li>
        The FAA applies to this Agreement and arbitration provision. We each
        agree that the FAA’s provisions–not state law–govern all questions of
        whether a dispute is subject to arbitration.
      </li>
      <li>
        Unless we each agree otherwise, the Arbitration will be conducted by a
        single neutral arbitrator and will take place in Essex County, New
        Jersey.
      </li>
      <li>
        The arbitration will be governed and conducted by (i) a neutral third
        party arbitrator selected by each of us and based upon rules mutually
        agreed to by each of us or (ii) JAMS. The JAMS rules, including rules
        about the selection of an arbitrator, filing, administration, discovery,
        and arbitrator fees, will be conducted under JAMS Comprehensive
        Arbitration Rules & Procedures. The JAMS rules are available on its
        website at www.jamsadr.com. To the extent that this “Dispute Resolution”
        section conflicts with JAMS’s minimum standards for procedural fairness,
        the JAMS’s rules or minimum standards for arbitration procedures in that
        regard will apply. However, nothing in this paragraph will require or
        allow us or you to arbitrate on a class-wide or consolidated basis.
      </li>
      <li>
        WE EACH AGREE THAT WE WILL ONLY PURSUE ARBITRATION ON AN INDIVIDUAL
        BASIS AND WILL NOT PURSUE ARBITRATION ON A CLASS-WIDE OR CONSOLIDATED
        BASIS. If for any reason any court or arbitrator holds that this
        restriction is unconscionable or unenforceable, then our agreement to
        arbitrate doesn’t apply and the dispute must be brought in court.
      </li>
      <li>
        We each are responsible for our respective costs relating to counsel,
        experts, and witnesses, as well as any other costs relating to the
        arbitration. However, we will pay for our half and part of your half of
        the arbitration administrative or filing fees, including the arbitrator
        fees. Pursuant to JAMS rules, you will only be responsible for $250 of
        such fees. For terms not explicitly set forth herein, the JAMS
        Comprehensive Arbitration Rules & Procedures and the JAMS Policy on
        Consumer Arbitrations Pursuant to Pre-Dispute Clauses, Minimum Standards
        of Procedural Fairness regarding costs and payment apply.
      </li>
      <li>Exceptions to Our Agreement to Arbitrate Disputes:</li>
    </ul>
    <p>
      Either of us may bring qualifying claims in small claims court. In
      addition, this arbitration provision does not prevent you from bringing
      your dispute to the attention of any federal, state, or local government
      agency that can, if the law allows, seek relief against us on your behalf.
    </p>
    <p>
      <b>8.3</b> To the extent allowed by law, we each waive any right to pursue
      disputes on a class-wide basis; that is, to either join a claim with the
      claim of any other person or entity or assert a claim in a representative
      capacity on behalf of anyone else in any lawsuit, arbitration, or other
      proceeding.
    </p>
    <p>
      <b>8.4</b> To the extent allowed by law, we each waive any right to trial
      by jury in any lawsuit, arbitration, or other proceeding.
    </p>
    <h4 class="mb-2 mt-2">9. LIABILITY OF LYCA MOBILE</h4>
    <p>
      <b>9.1</b> Lyca Mobile does not accept any liability for the delivery,
      performance and use of the Products and Services other than as stated in
      this Agreement.
    </p>
    <p>
      <b>9.2</b> Lyca Mobile is not responsible for damage or loss or
      inconvenience incurred by you and that results from the content of any
      voice call, message or data sent or received by you.
    </p>
    <p>
      <b>9.3</b> Lyca Mobile is not responsible for damage or loss or
      inconvenience incurred by you and that results from the involvement of a
      third party, including governmental, judicial or administrative bodies.
    </p>
    <p>
      <b>9.4</b> Lyca Mobile is not responsible for any damage or loss incurred
      by you where such damage or loss is indirect or not a reasonably
      foreseeable result of a breach by us, or where we are not at fault or to
      the extent you have contributed to the damage or loss. Under no
      circumstances is Lyca Mobile liable for any incidental, consequential,
      punitive, or special damages of any nature whatsoever arising out of or
      related to providing or failing to provide Services, including, but not
      limited to, lost profits, loss of business, or cost of replacement
      products and services.
    </p>
    <p>
      <b>9.5</b> In the event your SIM Card is lost or stolen, or you believe
      your SIM Card is being used in a fraudulent or improper manner by another
      person, you must promptly contact the Customer Services Department. Lyca
      Mobile will then be able to block the use of your SIM Card. If you fail to
      promptly contact the Customer Services Department, you will be liable for
      all Charges relating to the use of the SIM Card until you do notify us,
      regardless of whether the Charges were incurred by you or someone else.
    </p>
    <p>
      <b>9.6</b> Lyca Mobile is not responsible for the failure of any payment
      enabler, distributor or retail outlet to properly activate your SIM Card
      or Top-Up Voucher or process any payment you made. In these cases, you
      should contact the retail outlet where you obtained your SIM Card or
      purchased your Top-Up Voucher and request a refund.
    </p>
    <p>
      <b>9.7</b> You acknowledge the inherent risk in the use of a mobile
      telephone while driving a motor vehicle. Lyca Mobile is not responsible
      for damage or loss or inconvenience incurred by you and that results from
      any accident caused by the use of a mobile telephone while driving a motor
      vehicle.
    </p>
    <p>
      <b>9.8</b> To the extent allowed by law, lyca Mobile liability for
      monetary damages for any claims you may have against us is limited to a
      refund or rebate of the prorated monthly or other charges you paid us for
      the applicable services. you agree we are not liable for problems caused
      by you or a third party. except to the extent prohibited by law, all
      claims must be brought within 2 years of the date the claim arises.
    </p>
    <p>
      <b>9.9</b> Neither Lyca Mobile nor its affiliate companies, vendors,
      suppliers, or licensors are responsible for any damages, delay,
      interruption or other failure to perform resulting from: <br />(a)
      anything done or not done by someone other than Lyca Mobile; <br />(b)
      providing or failing to provide Services, including, but not limited to,
      deficiencies or problems with a Device or network coverage (for example,
      dropped, blocked, interrupted Services, etc.); <br />(c) traffic or other
      accidents, or any health-related claims relating to our Services;<br />
      (d) Data Content or information accessed while using our Services;<br />
      (e) an interruption or failure in accessing or attempting to access
      emergency services from a Device, including through 911, Enhanced 911 or
      otherwise; <br />(f) interrupted, failed, or inaccurate location
      information services;<br />
      (g) information or communication that is blocked by a spam filter;<br />
      (h) damage to your Device or any computer or equipment connected to your
      Device, or damage to or loss of any information stored on your Device,
      computer, equipment, or Lyca Mobile storage space from your use of the
      Services or from viruses, worms, or downloads of malicious content,
      materials, data, text, images, video, or audio; or <br />(i) things beyond
      our control, including acts of God (for example, weather-related
      phenomena, fire, earthquake, hurricane, etc.), riot, strike, war,
      terrorism, or government orders or acts. You should implement appropriate
      safeguards to secure your Device, computer, or equipment and to back-up
      your information stored thereon.
    </p>

    <h4 class="mb-2 mt-2">10. CHANGES TO THE AGREEMENT; WARRANTIES</h4>

    <p>
      <b>10.1</b> We may change any part of the Agreement (including the Privacy
      Policy) at any time, including, but not limited to Charges, how we
      determine and calculate Charges, discounts, coverage, technologies used to
      provide Services, or your terms of Service. We will provide you notice of
      material changes—and we may provide you notice of non-material changes—in
      a manner consistent with this Agreement (see Section 9.2 below). If you
      continue to access or use our Services or increase your account balance on
      or after the effective date of a change, you accept the change. Do not
      access or use our Services after the effective date of a change if you
      decide to reject the change and terminate Service. You will not be
      entitled to any credit for the unused portion of your account balance if
      you decide to terminate Service in response to a change to the Agreement.
    </p>
    <p>
      <b>10.2</b> Please check our website regularly for any changes. We may
      also notify you of changes by way of advertisement in the national media,
      by email, by correspondence to your last known address in our records, or
      by text message or by other reasonable means. We may also place a recorded
      message on the phone number for our Customer Services Department.
    </p>
    <p>
      10.3 UNLESS EXPRESSLY PROVIDED IN WRITING OTHERWISE, WE MAKE NO
      REPRESENTATIONS OR WARRANTIES, EXPRESS OR IMPLIED, INCLUDING (TO THE
      EXTENT ALLOWED BY LAW) ANY IMPLIED WARRANTY OF MERCHANTABILITY,
      NON-INFRINGEMENT, OR FITNESS FOR A PARTICULAR PURPOSE CONCERNING YOUR
      SERVICES. WE DON’T PROMISE UNINTERRUPTED OR ERROR-FREE SERVICES AND DON’T
      AUTHORIZE ANYONE TO MAKE WARRANTIES ON OUR BEHALF.
    </p>
    <h4 class="mb-2 mt-2">11. COMPLAINTS</h4>
    <p>
      <b>11.1</b> If you have a complaint about the Products or Services you
      should contact our Customer Service Department as set forth in Section
      1.6.
    </p>
    <h4 class="mb-2 mt-2">12. DEVICES</h4>
    <p>
      <b>12.1</b> Device and Compatibility : Not all Devices are compatible with
      Lyca Mobile Service. Your device must be unlocked (to work with any
      service provider network) or a T-Mobile authorized device. Lyca Mobile
      Service will not function properly or at all on certain frequencies not
      supported by T-Mobile, such a 1900 MHz (Band 2) frequencies. For example,
      data speeds are limited to 2G on older iOS devices such as iPhone 4/4s/5,
      iPad 3 Galaxy S4 and Gear S wearable. It is recommended to use 4G capable
      Devices with Lyca Mobile Service. Your Device must be compatible with and
      not potentially harm our network or that of our telecom partners
    </p>
    <p>
      <b>12.2</b> Lost or Stolen Devices. You agree to notify Lyca Mobile if
      your Device is lost or stolen. Once you notify us, we will suspend your
      Service. You agree to cooperate if we choose to investigate the matter
      (provide facts, sworn statements, etc.). After your Service is suspended,
      Lyca Mobile will credit you for any account balance that existed at the
      time of the notification. Lyca Mobile will allow any balance to be
      transferred to a replacement SIM or Device. Lyca Mobile will not be
      responsible for usage charges that deplete your account balance prior to
      your report, nor for the cost of any replacement Device. Lyca Mobile will
      supply one replacement SIM at no cost to you by regular mail as soon as
      reasonably practical. If you request that we not suspend your Service, you
      will remain responsible for all usage. We may prevent a lost or stolen
      Device from registering on the network. California customers: For Charges
      incurred before you notify us, you are not liable for Charges you did not
      authorize, but the fact that your Device or Account was used is evidence
      of authorization. You may request that Lyca Mobile investigate Charges you
      believe were unauthorized. We may ask you to provide information and you
      may submit information to support your request. If we determine the
      Charges were unauthorized, we will credit your account. If we determine
      the Charges were authorized, we will inform you within thirty (30) days
      and you will remain responsible for the Charges.
    </p>
    <p>
      <b>12.3</b> Your Device, Number, & E-mail Address Lyca Mobile does not
      manufacture any Device that Lyca Mobile might sell to you or that is
      associated with our Services, and Lyca Mobile isn’t responsible for any
      defects, acts, or omissions of the manufacturer.
      <b
        >The only warranties on your Device are the limited warranties given to
        you by the manufacturer directly or that we pass through. Device
        performance may vary based on device specifications (for example, a
        device’s software, memory, and storage), and device performance may
        impact access to all of our Services.</b
      >
      Device warranty procedures and repairs will be listed with the Device
      purchase materials. Except for any legal right you may have to
      port/transfer your phone number to another carrier, you have no
      proprietary, ownership, or other rights to any phone number,
      identification number, e-mail address, or other identifier that we assign
      to you, your Device, or your account, and you cannot gain any such right
      through publication, use, or similar action. We’ll notify you if we decide
      to change or reassign any such identifier.
    </p>
    <p>
      <b>12.4</b> Information on Devices: . Your Device may contain sensitive or
      personal information (for example, pictures, videos, passwords, or stored
      credit card numbers). Lyca Mobile is not responsible for any information
      on your Device, including sensitive or personal information. If possible,
      you should remove or otherwise safeguard any sensitive or personal
      information when your Device is out of your possession or control, for
      example when you relinquish, exchange, return, or recycle your Device. By
      submitting your Device to Lyca Mobile or our authorized dealers or
      supporting vendors, you agree that their employees, contractors, or
      vendors may access all of the information on your Device. If you exchange,
      return, or recycle your Device through Lyca Mobile, we typically attempt
      to erase all data on your Device, but you must remove all data from your
      Device before you provide it to us.
    </p>
    <p>
      <b>12.5</b> Disclaimer of Warranties UNLESS OTHERWISE EXPRESSLY PROVIDED
      IN WRITING, LYCA MOBILE MAKES NO REPRESENTATIONS OR WARRANTIES, EXPRESS OR
      IMPLIED, INCLUDING (TO THE EXTENT ALLOWED BY LAW) ANY IMPLIED WARRANTY OF
      MERCHANTABILITY, NON-INFRINGEMENT, OR FITNESS FOR A PARTICULAR PURPOSE
      CONCERNING YOUR DEVICE (AND ANY SOFTWARE OR APPLICATIONS ON YOUR DEVICE).
      WE DON’T PROMISE UNINTERRUPTED OR ERROR-FREE SERVICES AND DON’T AUTHORIZE
      ANYONE TO MAKE WARRANTIES ON OUR BEHALF. LYCA MOBILE PROVIDES ALL SOFTWARE
      AND APPLICATIONS ON AN “AS IS” BASIS WITH ALL FAULTS, ERRORS, AND DEFECTS.
    </p>

    <h4 class="mb-2 mt-2">13. GENERAL PROVISIONS</h4>
    <p>
      <b>13.1</b> This Agreement represents the entire agreement between Lyca
      Mobile and you in relation to the Products and Services. It takes
      precedence over all prior agreements (written and oral), and all
      representations or other communications between Lyca Mobile and you. The
      retail outlets are not authorized by us to amend this Agreement or to
      agree any terms which are inconsistent with these terms and conditions.
    </p>
    <p>
      <b>13.2</b> No term or condition of this Agreement is enforceable by any
      third party (a person who is not a party to this Agreement).
    </p>
    <p>
      <b>13.3</b> Failure or delay by either Lyca Mobile or the Customer to
      enforce any right under this Agreement shall not prevent Lyca Mobile or
      the Customer (as the case may be) from taking further action.
    </p>
    <p>
      <b>13.4</b> If any term or condition of this Agreement is determined to be
      partially or wholly void or unenforceable by any court or body of
      competent jurisdiction or as a result of any legislation, it shall be void
      and unenforceable only to that extent. The validity and enforceability of
      the other terms and conditions shall not be affected.
    </p>
    <p>
      <b>13.5</b> Lyca Mobile is entitled to assign all of its rights and
      obligations under this Agreement to a third party. You are entitled to
      assign all of your rights and obligations under this Agreement to a third
      party with the written consent of Lyca Mobile.
    </p>
    <p>
      <b>13.6</b> Subject to federal law or unless the Agreement specifically
      provides otherwise, this Agreement is governed solely by the laws of the
      state encompassing the area code assigned to your SIM, without regard to
      the conflicts of law rules of that state. Subject to the provisions of
      Section 7, the courts of the state of New Jersey will have exclusive
      jurisdiction over any dispute under this Agreement.
    </p>
    <p>
      <b>13.7</b> 911 Or Other Emergency Calls: Public safety officials advise
      that when making 911 or other emergency calls, you should always be
      prepared to provide your location information. Unlike traditional wireline
      phones, depending on a number of factors (for example, whether your Device
      is GPS-enabled, where you are, whether local emergency service providers
      have upgraded their equipment, etc.), 911 operators may not know your
      phone number, your location, or the location of your Device. In certain
      circumstances, an emergency call may be routed to a state patrol
      dispatcher or alternative location set by local emergency service
      providers. Enhanced 911 service (“E911”) –where enabled by local emergency
      authorities– uses GPS technology to provide location information. Even
      when available, however, E911 does not always provide accurate location
      information. If your Device is indoors or for some other reason cannot
      acquire a satellite signal, you may not be located. Some Devices have a
      safety feature that prevents use of the keypad after dialing 911–you
      should follow voice prompts when interacting with emergency service
      providers employing interactive voice response systems to screen calls.
    </p>
    <h4 class="mb-2 mt-2">
      14. For promotional SMS service related FAQs, please visit.
    </h4>
  </div>
</template>
<script>
export default {
  name: "TermsAndConditions",
};
</script>
<style scoped>
ul {
  list-style-type: disc;
  padding-left: 15px;
}
ol {
  list-style-type: lower-alpha;
  padding-left: 15px;
}
b {
  font-weight: 600;
}
p {
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>
